import { useTranslation } from 'react-i18next'
import { MailIcon, MessageCircleIcon } from 'lucide-react'

interface SendActionsProps {
	onSendChat?:  () => void
	onSendEmail?: () => void
}

interface ActionRowProps {
	icon:    React.ReactNode
	label:   string
	onClick?: () => void
}

function ActionRow({ icon, label, onClick }: ActionRowProps) {
	return (
		<button
			type="button"
			onClick={onClick}
			className="flex items-center gap-3 rounded-(--radius-sm) py-1.5 text-left transition-colors hover:bg-(--color-muted)"
		>
			<span className="flex size-9 items-center justify-center rounded-(--radius-sm) bg-(--color-primary)/10 text-(--color-primary)">
				{icon}
			</span>
			<span className="text-sm text-(--color-info)">{label}</span>
		</button>
	)
}

export function SendActions({ onSendChat, onSendEmail }: SendActionsProps) {
	const { t } = useTranslation()
	return (
		<section className="flex flex-col gap-2">
			<h4 className="text-sm font-[500] text-(--color-foreground)">{t('rent.invoices.details.send.title')}</h4>
			<div className="flex flex-col">
				<ActionRow
					icon={<MessageCircleIcon className="size-4" />}
					label={t('rent.invoices.details.send.chat')}
					onClick={onSendChat}
				/>
				<ActionRow
					icon={<MailIcon className="size-4" />}
					label={t('rent.invoices.details.send.email')}
					onClick={onSendEmail}
				/>
			</div>
		</section>
	)
}
